import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Modal, Tabs, Divider, Slider, Space, Card, message, Tooltip } from 'antd';
import Icon from '@components/Icon';
import stores from '@stores';
import { nanoid } from '@utils/utils';

// 贴纸类别和贴纸列表 - 使用在线CDN中的真实贴纸图片
const stickerCategories = [
  {
    key: 'emoji',
    tab: '表情',
    stickers: [
      { id: 'emoji1', src: 'https://cdn-icons-png.flaticon.com/512/742/742850.png', name: '开心' },
      { id: 'emoji2', src: 'https://cdn-icons-png.flaticon.com/512/742/742923.png', name: '微笑' },
      { id: 'emoji3', src: 'https://cdn-icons-png.flaticon.com/512/742/742774.png', name: '伤心' },
      { id: 'emoji4', src: 'https://cdn-icons-png.flaticon.com/512/742/742770.png', name: '大笑' },
      { id: 'emoji5', src: 'https://cdn-icons-png.flaticon.com/512/742/742822.png', name: '调皮' },
      { id: 'emoji6', src: 'https://cdn-icons-png.flaticon.com/512/742/742815.png', name: '可爱' },
      { id: 'emoji7', src: 'https://cdn-icons-png.flaticon.com/512/742/742869.png', name: '惊讶' },
      { id: 'emoji8', src: 'https://cdn-icons-png.flaticon.com/512/742/742753.png', name: '愤怒' },
      { id: 'emoji9', src: 'https://cdn-icons-png.flaticon.com/512/742/742758.png', name: '困倦' },
      { id: 'emoji10', src: 'https://cdn-icons-png.flaticon.com/512/742/742888.png', name: '思考' },
      { id: 'emoji11', src: 'https://cdn-icons-png.flaticon.com/512/742/742910.png', name: '酷' },
      { id: 'emoji12', src: 'https://cdn-icons-png.flaticon.com/512/742/742917.png', name: '爱心眼' }
    ]
  },
  {
    key: 'social',
    tab: '社交',
    stickers: [
      { id: 'social1', src: 'https://cdn-icons-png.flaticon.com/512/3128/3128304.png', name: '点赞' },
      { id: 'social2', src: 'https://cdn-icons-png.flaticon.com/512/3128/3128313.png', name: '爱心' },
      { id: 'social3', src: 'https://cdn-icons-png.flaticon.com/512/5968/5968764.png', name: '微信' },
      { id: 'social4', src: 'https://cdn-icons-png.flaticon.com/512/1384/1384031.png', name: '微博' },
      { id: 'social5', src: 'https://cdn-icons-png.flaticon.com/512/889/889102.png', name: '分享' },
      { id: 'social6', src: 'https://cdn-icons-png.flaticon.com/512/2504/2504947.png', name: '视频' },
      { id: 'social7', src: 'https://cdn-icons-png.flaticon.com/512/5968/5968841.png', name: '推特' },
      { id: 'social8', src: 'https://cdn-icons-png.flaticon.com/512/5968/5968793.png', name: 'QQ' },
      { id: 'social9', src: 'https://cdn-icons-png.flaticon.com/512/145/145807.png', name: 'LinkedIn' },
      { id: 'social10', src: 'https://cdn-icons-png.flaticon.com/512/3128/3128219.png', name: '评论' },
      { id: 'social11', src: 'https://cdn-icons-png.flaticon.com/512/9868/9868249.png', name: '消息' },
      { id: 'social12', src: 'https://cdn-icons-png.flaticon.com/512/1077/1077035.png', name: '相机' }
    ]
  },
  {
    key: 'food',
    tab: '食物',
    stickers: [
      { id: 'food1', src: 'https://cdn-icons-png.flaticon.com/512/3075/3075977.png', name: '汉堡' },
      { id: 'food2', src: 'https://cdn-icons-png.flaticon.com/512/3075/3075983.png', name: '披萨' },
      { id: 'food3', src: 'https://cdn-icons-png.flaticon.com/512/2361/2361438.png', name: '热狗' },
      { id: 'food4', src: 'https://cdn-icons-png.flaticon.com/512/3075/3075929.png', name: '冰淇淋' },
      { id: 'food5', src: 'https://cdn-icons-png.flaticon.com/512/2965/2965567.png', name: '蛋糕' },
      { id: 'food6', src: 'https://cdn-icons-png.flaticon.com/512/3075/3075918.png', name: '咖啡' }
    ]
  },
  {
    key: 'animals',
    tab: '动物',
    stickers: [
      { id: 'animal1', src: 'https://cdn-icons-png.flaticon.com/512/616/616430.png', name: '猫咪' },
      { id: 'animal2', src: 'https://cdn-icons-png.flaticon.com/512/616/616408.png', name: '狗狗' },
      { id: 'animal3', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998610.png', name: '大熊猫' },
      { id: 'animal4', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998713.png', name: '狐狸' },
      { id: 'animal5', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998627.png', name: '兔子' },
      { id: 'animal6', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998679.png', name: '狮子' }
    ]
  },
  {
    key: 'badges',
    tab: '徽章',
    stickers: [
      { id: 'badge1', src: 'https://cdn-icons-png.flaticon.com/512/3176/3176401.png', name: '销售标签' },
      { id: 'badge2', src: 'https://cdn-icons-png.flaticon.com/512/3800/3800024.png', name: '推荐' },
      { id: 'badge3', src: 'https://cdn-icons-png.flaticon.com/512/4254/4254068.png', name: '折扣' },
      { id: 'badge4', src: 'https://cdn-icons-png.flaticon.com/512/2643/2643513.png', name: '认证' },
      { id: 'badge5', src: 'https://cdn-icons-png.flaticon.com/512/2799/2799312.png', name: '奖章' },
      { id: 'badge6', src: 'https://cdn-icons-png.flaticon.com/512/1647/1647825.png', name: '新品' }
    ]
  },
  {
    key: 'arrows',
    tab: '箭头',
    stickers: [
      { id: 'arrow1', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542617.png', name: '上箭头' },
      { id: 'arrow2', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542585.png', name: '下箭头' },
      { id: 'arrow3', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542577.png', name: '左箭头' },
      { id: 'arrow4', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542605.png', name: '右箭头' },
      { id: 'arrow5', src: 'https://cdn-icons-png.flaticon.com/512/8173/8173000.png', name: '双向箭头' },
      { id: 'arrow6', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542654.png', name: '圆形箭头' }
    ]
  },
  {
    key: 'tech',
    tab: '科技',
    stickers: [
      { id: 'tech1', src: 'https://cdn-icons-png.flaticon.com/512/1055/1055687.png', name: '手机' },
      { id: 'tech2', src: 'https://cdn-icons-png.flaticon.com/512/3174/3174862.png', name: '电脑' },
      { id: 'tech3', src: 'https://cdn-icons-png.flaticon.com/512/3659/3659898.png', name: '平板' },
      { id: 'tech4', src: 'https://cdn-icons-png.flaticon.com/512/5968/5968705.png', name: 'GitHub' },
      { id: 'tech5', src: 'https://cdn-icons-png.flaticon.com/512/2721/2721305.png', name: '耳机' },
      { id: 'tech6', src: 'https://cdn-icons-png.flaticon.com/512/3178/3178158.png', name: '游戏' },
      { id: 'tech7', src: 'https://cdn-icons-png.flaticon.com/512/3247/3247956.png', name: '电池' },
      { id: 'tech8', src: 'https://cdn-icons-png.flaticon.com/512/3616/3616952.png', name: '充电器' }
    ]
  },
  {
    key: 'holiday',
    tab: '节日',
    stickers: [
      { id: 'holiday1', src: 'https://cdn-icons-png.flaticon.com/512/6270/6270077.png', name: '圣诞树' },
      { id: 'holiday2', src: 'https://cdn-icons-png.flaticon.com/512/3827/3827883.png', name: '红包' },
      { id: 'holiday3', src: 'https://cdn-icons-png.flaticon.com/512/9381/9381177.png', name: '生日蛋糕' },
      { id: 'holiday4', src: 'https://cdn-icons-png.flaticon.com/512/9474/9474449.png', name: '烟花' },
      { id: 'holiday5', src: 'https://cdn-icons-png.flaticon.com/512/5341/5341066.png', name: '月饼' },
      { id: 'holiday6', src: 'https://cdn-icons-png.flaticon.com/512/6020/6020579.png', name: '福字' },
      { id: 'holiday7', src: 'https://cdn-icons-png.flaticon.com/512/7896/7896624.png', name: '元宵灯笼' },
      { id: 'holiday8', src: 'https://cdn-icons-png.flaticon.com/512/2173/2173478.png', name: '礼物' }
    ]
  },
  {
    key: 'travel',
    tab: '旅行',
    stickers: [
      { id: 'travel1', src: 'https://cdn-icons-png.flaticon.com/512/3125/3125856.png', name: '飞机' },
      { id: 'travel2', src: 'https://cdn-icons-png.flaticon.com/512/9749/9749908.png', name: '行李箱' },
      { id: 'travel3', src: 'https://cdn-icons-png.flaticon.com/512/9802/9802063.png', name: '地球仪' },
      { id: 'travel4', src: 'https://cdn-icons-png.flaticon.com/512/10410/10410100.png', name: '沙滩椅' },
      { id: 'travel5', src: 'https://cdn-icons-png.flaticon.com/512/819/819560.png', name: '路标' },
      { id: 'travel6', src: 'https://cdn-icons-png.flaticon.com/512/10522/10522640.png', name: '相机' },
      { id: 'travel7', src: 'https://cdn-icons-png.flaticon.com/512/3028/3028283.png', name: '护照' },
      { id: 'travel8', src: 'https://cdn-icons-png.flaticon.com/512/1533/1533105.png', name: '地图' }
    ]
  },
  {
    key: 'fashion',
    tab: '时尚',
    stickers: [
      { id: 'fashion1', src: 'https://cdn-icons-png.flaticon.com/512/2589/2589903.png', name: '时尚眼镜' },
      { id: 'fashion2', src: 'https://cdn-icons-png.flaticon.com/512/1785/1785350.png', name: '帽子' },
      { id: 'fashion3', src: 'https://cdn-icons-png.flaticon.com/512/1785/1785378.png', name: '衬衫' },
      { id: 'fashion4', src: 'https://cdn-icons-png.flaticon.com/512/1940/1940922.png', name: '包包' },
      { id: 'fashion5', src: 'https://cdn-icons-png.flaticon.com/512/1150/1150327.png', name: '裙子' },
      { id: 'fashion6', src: 'https://cdn-icons-png.flaticon.com/512/1040/1040254.png', name: '鞋子' },
      { id: 'fashion7', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998531.png', name: '礼服' },
      { id: 'fashion8', src: 'https://cdn-icons-png.flaticon.com/512/700/700618.png', name: '领带' }
    ]
  },
  {
    key: 'business',
    tab: '商务',
    stickers: [
      { id: 'business1', src: 'https://cdn-icons-png.flaticon.com/512/3208/3208723.png', name: '图表' },
      { id: 'business2', src: 'https://cdn-icons-png.flaticon.com/512/2501/2501143.png', name: '公文包' },
      { id: 'business3', src: 'https://cdn-icons-png.flaticon.com/512/2541/2541988.png', name: '合同' },
      { id: 'business4', src: 'https://cdn-icons-png.flaticon.com/512/3395/3395949.png', name: '会议' },
      { id: 'business5', src: 'https://cdn-icons-png.flaticon.com/512/4149/4149679.png', name: '商务讨论' },
      { id: 'business6', src: 'https://cdn-icons-png.flaticon.com/512/4300/4300059.png', name: '证书' },
      { id: 'business7', src: 'https://cdn-icons-png.flaticon.com/512/3050/3050525.png', name: '日历' },
      { id: 'business8', src: 'https://cdn-icons-png.flaticon.com/512/5064/5064074.png', name: '钱包' }
    ]
  },
  {
    key: 'nature',
    tab: '自然',
    stickers: [
      { id: 'nature1', src: 'https://cdn-icons-png.flaticon.com/512/6115/6115220.png', name: '山脉' },
      { id: 'nature2', src: 'https://cdn-icons-png.flaticon.com/512/616/616438.png', name: '树木' },
      { id: 'nature3', src: 'https://cdn-icons-png.flaticon.com/512/4215/4215245.png', name: '花朵' },
      { id: 'nature4', src: 'https://cdn-icons-png.flaticon.com/512/4213/4213763.png', name: '叶子' },
      { id: 'nature5', src: 'https://cdn-icons-png.flaticon.com/512/4213/4213736.png', name: '仙人掌' },
      { id: 'nature6', src: 'https://cdn-icons-png.flaticon.com/512/2869/2869627.png', name: '太阳' },
      { id: 'nature7', src: 'https://cdn-icons-png.flaticon.com/512/1779/1779940.png', name: '月亮' },
      { id: 'nature8', src: 'https://cdn-icons-png.flaticon.com/512/1146/1146856.png', name: '云朵' },
      { id: 'nature9', src: 'https://cdn-icons-png.flaticon.com/512/2204/2204543.png', name: '彩虹' },
      { id: 'nature10', src: 'https://cdn-icons-png.flaticon.com/512/2925/2925334.png', name: '雪花' },
      { id: 'nature11', src: 'https://cdn-icons-png.flaticon.com/512/3104/3104619.png', name: '海浪' },
      { id: 'nature12', src: 'https://cdn-icons-png.flaticon.com/512/2758/2758123.png', name: '星星' }
    ]
  }
];

const StickerTool = observer(() => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentCategory, setCurrentCategory] = useState('emoji');
  const [stickerScale, setStickerScale] = useState(1);
  const [stickerRotation, setStickerRotation] = useState(0);
  const [previewSticker, setPreviewSticker] = useState(null);
  
  // 打开贴纸选择器
  const showStickerModal = () => {
    if (!stores.editor.isEditing) {
      message.info('请先添加图片');
      return;
    }
    setIsModalOpen(true);
  };
  
  // 关闭贴纸选择器
  const handleCancel = () => {
    setIsModalOpen(false);
    setPreviewSticker(null);
  };
  
  // 预览贴纸
  const handleStickerHover = (sticker) => {
    setPreviewSticker(sticker);
  };
  
  // 重置预览
  const handleStickerLeave = () => {
    setPreviewSticker(null);
  };
  
  // 添加贴纸到画布
  const addStickerToCanvas = (sticker) => {
    if (!stores.editor.isEditing) return;
    
    // 计算画布中心位置
    const frameBox = stores.editor.app.editor.parent.children.find(child => child.tag === 'framebox');
    const centerX = frameBox ? frameBox.width / 2 : stores.option.frameConf.width / 2;
    const centerY = frameBox ? frameBox.height / 2 : stores.option.frameConf.height / 2;
    
    // 添加贴纸
    stores.editor.addShape({
      id: nanoid(),
      type: 'image',
      src: sticker.src,
      zIndex: stores.editor.shapes.size + 1,
      x: centerX - 40,
      y: centerY - 40,
      width: 80 * stickerScale,
      height: 80 * stickerScale,
      rotation: stickerRotation,
      editable: true
    });
    
    // 关闭模态框
    setIsModalOpen(false);
    setPreviewSticker(null);
    
    // 显示成功消息
    message.success(`已添加"${sticker.name}"贴纸`);
    
    // 重置工具状态
    stores.editor.setUseTool(null);
  };
  
  // 获取当前类别的所有贴纸
  const getCurrentCategoryStickers = () => {
    const category = stickerCategories.find(cat => cat.key === currentCategory);
    return category ? category.stickers : [];
  };
  
  return (
    <>
      <Button
        type="text"
        className="w-full flex items-center justify-start rounded-md px-2 py-1 h-auto hover:bg-purple-50 dark:hover:bg-gray-800 hover:text-purple-600 dark:hover:text-purple-400"
        onClick={showStickerModal}
      >
        <Icon.Sticker size={18} useFa={true} className="mr-2" />
        <span className="text-xs">添加贴纸</span>
      </Button>
      
      <Modal
        title={
          <div className="flex items-center text-purple-600 dark:text-purple-400">
            <Icon.Sticker size={20} useFa={true} className="mr-2" />
            <span>添加贴纸</span>
          </div>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={720}
        className="sticker-modal"
        maskStyle={{ background: 'rgba(0, 0, 0, 0.45)' }}
        bodyStyle={{ padding: "16px", background: stores.editor.isDark ? "#1f2937" : "#f8fafc" }}
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-2">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm mb-4">
              <Divider orientation="left" orientationMargin="0" className="text-xs text-gray-500 dark:text-gray-400 my-1">
                <div className="flex items-center">
                  <Icon.Sliders size={12} useFa={true} className="mr-1 text-purple-500 dark:text-purple-400" />
                  <span>贴纸设置</span>
                </div>
              </Divider>
              
              <div className="mb-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs">缩放比例</span>
                  <span className="text-xs text-gray-500">{stickerScale.toFixed(1)}x</span>
                </div>
                <Slider
                  min={0.5}
                  max={3}
                  step={0.1}
                  value={stickerScale}
                  onChange={setStickerScale}
                />
              </div>
              
              <div className="mb-2">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs">旋转角度</span>
                  <span className="text-xs text-gray-500">{stickerRotation}°</span>
                </div>
                <Slider
                  min={-180}
                  max={180}
                  value={stickerRotation}
                  onChange={setStickerRotation}
                />
              </div>
            </div>
            
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm">
              <Divider orientation="left" orientationMargin="0" className="text-xs text-gray-500 dark:text-gray-400 my-1">
                <div className="flex items-center">
                  <Icon.Sticker size={12} useFa={true} className="mr-1 text-purple-500 dark:text-purple-400" />
                  <span>选择贴纸</span>
                </div>
              </Divider>
              
              <Tabs 
                activeKey={currentCategory}
                onChange={setCurrentCategory}
                className="sticker-tabs"
                items={stickerCategories.map(category => ({
                  key: category.key,
                  label: category.tab,
                  children: (
                    <div className="grid grid-cols-3 md:grid-cols-4 gap-3 p-2">
                      {category.stickers.map(sticker => (
                        <Tooltip 
                          key={sticker.id} 
                          title={sticker.name}
                          mouseEnterDelay={0.5}
                        >
                          <Card
                            hoverable
                            className="flex flex-col justify-center items-center p-1 cursor-pointer hover:border-purple-500 dark:hover:border-purple-400"
                            onClick={() => addStickerToCanvas(sticker)}
                            onMouseEnter={() => handleStickerHover(sticker)}
                            onMouseLeave={handleStickerLeave}
                            bordered
                          >
                            <div className="w-full h-16 flex items-center justify-center">
                              <img 
                                src={sticker.src} 
                                alt={sticker.name} 
                                className="max-w-full max-h-full object-contain"
                              />
                            </div>
                            <div className="mt-1 text-xs truncate w-full text-center">{sticker.name}</div>
                          </Card>
                        </Tooltip>
                      ))}
                    </div>
                  )
                }))}
              />
            </div>
          </div>
          
          <div className="hidden md:block">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm h-full">
              <Divider orientation="left" orientationMargin="0" className="text-xs text-gray-500 dark:text-gray-400 my-1">
                <div className="flex items-center">
                  <Icon.ZoomIn size={12} className="mr-1 text-purple-500 dark:text-purple-400" />
                  <span>预览</span>
                </div>
              </Divider>
              
              <div className="sticker-preview-container p-4 flex flex-col items-center justify-center h-[calc(100%-40px)]">
                <div className="sticker-preview flex-1 flex items-center justify-center w-full">
                  {previewSticker ? (
                    <img 
                      src={previewSticker.src} 
                      alt={previewSticker.name}
                      style={{ 
                        transform: `scale(${stickerScale}) rotate(${stickerRotation}deg)`,
                        maxWidth: '80%',
                        maxHeight: '80%'
                      }}
                    />
                  ) : (
                    <div className="text-center text-gray-400 dark:text-gray-500">
                      <Icon.Sticker size={48} useFa={true} className="mb-2 opacity-50" />
                      <p className="text-sm">悬停在贴纸上预览效果</p>
                    </div>
                  )}
                </div>
                
                {previewSticker && (
                  <Button 
                    type="primary" 
                    className="mt-4 bg-purple-600 hover:bg-purple-700 border-purple-600"
                    onClick={() => addStickerToCanvas(previewSticker)}
                  >
                    添加到画布
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
});

export default StickerTool; 